const WITNESS_TEST_OPTIONS = {
  SMOKE_CONTROL: {display: 'Smoke Control', value: 'Smoke Control', showOrder: 0, def: false},
  HEATING_COOLING: {display: 'Heating/Cooling Equipment', value: 'Heating/Cooling Equipment', showOrder: 1, def: false},
  VENTILATION: {display: 'Ventilation System', value: 'Ventilation System', showOrder: 2, def: false},
};

export {WITNESS_TEST_OPTIONS};